<div class="flex flex-col">
  <h2 class="center-text">Venues Historical Cancellations</h2>
  <div class="flex w-100 justify-between items-center">
    <div class="flex items-end justify-center gap-2">
      <div>
        <label class="label">From</label>
        <input type="date" [(ngModel)]="date_from" class="input-field" />
      </div>
      <div>
        <label class="label">To</label>
        <input type="date" [(ngModel)]="date_to" class="input-field" />
      </div>
      <button (click)="fetchReport()" class="plain-button ml-10">Submit</button>
    </div>
    <div>
      <button class="plain-button" (click)="exportReport()">Download (CSV)</button>
    </div>
  </div>
  <!-- table -->
  <table class="reports-table">
    <thead>
      <tr>
        <th>Venue</th>
        <th>Client</th>
        <th>Duration (Weeks)</th>
        <th>Games Scheduled</th>
        <th>Games Canceled (Before Arrival)</th>
        <th>Games Canceled (After Arrival)</th>
      </tr>
    </thead>

    <tbody *ngIf="!fetching">
      <tr *ngFor="let cancellation of cancellationsReport; else noRecord">
        <td>{{ cancellation.venue_name }}</td>
        <td>{{ cancellation.client_name }}</td>
        <td>{{ cancellation.active_weeks }}</td>
        <td>{{ cancellation.total_scheduled_games }}</td>
        <td>{{ cancellation.canceled_before_arrival }}</td>
        <td>{{ cancellation.canceled_on_arrival }}</td>
      </tr>
    </tbody>
    <tbody *ngIf="fetching">
      <tr>
        <td colspan="6" class="center-text">Loading...</td>
      </tr>
    </tbody>
  </table>
</div>

<ng-template #noRecord>
  <tr>
    <td colspan="6" class="center-text">No Record Found</td>
  </tr>
</ng-template>
